import {
  Button,
  Heading,
  Modal,
  Subtitle,
  TextInput,
  Title,
} from 'components/common';
import notification from 'lib/notification';
import { useState } from 'react';
import { isNil, isEmpty } from 'lib/javascript';

interface RedeemCodeModalProps {
  isOpen: boolean;
  onClose?: () => void;
  onRedeem: (code: string) => Promise<void>;
  title?: string;
  partnerName?: string | null;
}

export const RedeemCodeModal = ({
  isOpen,
  onClose,
  onRedeem,
  title,
  partnerName,
}: RedeemCodeModalProps) => {
  const [isRedeeming, setIsRedeeming] = useState(false);
  const [code, setCode] = useState('');
  const partner =
    !isNil(partnerName) && !isEmpty(partnerName)
      ? partnerName
      : 'Yummy Bros';

  const handleOnRedeem = async () => {
    try {
      setIsRedeeming(true);
      await onRedeem(code);
      notification.success('Successfully redeem perk reward');
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.message ||
        error.message ||
        'Something went wrong. Please try again.';
      notification.error(errorMessage);
    } finally {
      setIsRedeeming(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onHide={onClose}
      centered
      backdrop={isRedeeming ? 'static' : true}
      className="tw-z-[1070]"
    >
      <Modal.Body>
        <div className="tw-flex tw-flex-col tw-justify-start tw-w-full tw-text-left">
          <Heading>
            {title && <Title>How to Redeem {title}</Title>}
            {partner && (
              <Subtitle>
                Just head on down to <strong>{partner}’s</strong>{' '}
                specified outlets and show the staff this screen!
              </Subtitle>
            )}
          </Heading>
          <TextInput
            // @ts-ignore
            label="Redemption Code"
            required
            onChange={(e) => setCode(e.target.value)}
          />
          <div className="tw-flex tw-justify-end tw-gap-x-4">
            <Button
              onClick={handleOnRedeem}
              disabled={!code.length || isRedeeming}
              loading={isRedeeming}
            >
              <>Redeem</>
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
